<template>
  <v-container grid-list-xl>
    <v-layout row mt-3>
      <v-flex xs12 md10 offset-md1 lg8 offset-lg2 xl6 offset-xl3>
        <div>
          <v-toolbar color="red darken-4" dark tabs>
            <v-tabs
              v-model="tabs"
              fixed-tabs
              dark
              color="transparent"
              slider-color="white"
            >
              <!--              <v-tab v-for="(item, i) in items" :key="i" :href="'#tab-' + i">-->
              <!--                <strong>{{ item.name }}</strong>-->
              <!--              </v-tab>-->
              <v-tab href="#tab-0">
                <strong>Buy</strong>
              </v-tab>
              <v-tab href="#tab-1">
                <strong>Sell</strong>
              </v-tab>
            </v-tabs>
          </v-toolbar>
          <v-tabs-items v-model="tabs">
            <!--            <v-tab-item v-for="(item, i) in items" :key="i" :value="'tab-' + i">-->
            <!--              <v-card elevation="15">-->
            <!--                <v-card-title primary-title>-->
            <!--                  <div>-->
            <!--                    <h3 class="headline mb-0 blue&#45;&#45;text text&#45;&#45;darken-4">-->
            <!--                      {{ item.title }}-->
            <!--                    </h3>-->
            <!--                    <div class="subheading font-weight-light">-->
            <!--                      {{ item.body }}-->
            <!--                    </div>-->
            <!--                  </div>-->
            <!--                </v-card-title>-->
            <!--                <v-card-text>-->
            <!--                  <short-search-form-->
            <!--                    :label="item.text"-->
            <!--                    :query-type="item.queryType"-->
            <!--                  ></short-search-form>-->
            <!--                </v-card-text>-->
            <!--              </v-card>-->
            <!--            </v-tab-item>-->
            <v-tab-item :value="'tab-' + 0">
              <v-card elevation="15">
                <v-card-title primary-title>
                  <div>
                    <h3 class="headline mb-0 blue--text text--darken-4">
                      Find Your New Home
                    </h3>
                    <div class="subheading font-weight-light">
                      Search listings in your preferred area
                    </div>
                  </div>
                </v-card-title>
                <v-card-text>
                  <short-search-form
                    label="Search for City, Address, Community, Zip Code"
                  ></short-search-form>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item :value="'tab-' + 1">
              <v-card elevation="15">
                <v-card-title primary-title>
                  <div>
                    <h3 class="headline mb-0 blue--text text--darken-4">
                      Sell Your Home
                    </h3>
                    <div class="subheading font-weight-light">
                      As little as 1.5% listing fee
                    </div>
                  </div>
                </v-card-title>
                <v-card-text>
                  <p>
                    We will gladly sell your home for the best possible price.
                    Please fill out the sellers form.
                  </p>
                  <div>
                    <v-btn
                      color="primary"
                      dark
                      large
                      @click.prevent="sellerForm"
                    >
                      Sell Your Home
                    </v-btn>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import ShortSearchForm from './ShortSearchForm';

export default {
  name: 'SearchCTA',
  components: {
    ShortSearchForm,
  },
  data() {
    return {
      tabs: null,
    };
  },
  methods: {
    sellerForm() {
      this.$router.push({ name: 'contact' });
    },
  },
};
</script>
